import { KgInsightFilterRequest } from '@api/api/kg-insights';
import { useQuery } from '@tanstack/react-query';
import { getKgInsightFilter } from '@terminal/services/insights/kg-insights-service';

export const QUERY_KEY_KG_INSIGHT_FILTER = 'QUERY_KEY_KG_INSIGHT_FILTER';

export const useKgInsightFilter = (
  body: KgInsightFilterRequest,
  isEnabled = true
) =>
  useQuery({
    queryKey: [QUERY_KEY_KG_INSIGHT_FILTER, body],
    queryFn: ({ signal }) => getKgInsightFilter(body, signal),
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60,
  });
